import { requests } from 'api';
import { Moment } from './types';

const apiBaseUrl = '/api/moments';

export const MomentsApi = {
  getAll: (): Promise<Moment[]> => requests.get(apiBaseUrl),
};
